import { render } from "./confirm.vue?vue&type=template&id=427269e2&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=ts"
export * from "./confirm.vue?vue&type=script&lang=ts"

import "./confirm.vue?vue&type=style&index=0&id=427269e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-427269e2"

export default script